export default function truncateTitle(title) {
  const length = 58;
  const ending = '...';

  if (title.length > length) {
    return title.substring(0, length - ending.length) + ending;
  }

  return title;
}
